import { GTMAccommodationItem } from "@/helpers/gtm/GTMAccommodationItem.ts";
import { GTMEvent } from "@/helpers/gtm/GTMEvent.ts";
import { RateGroup } from "@/helpers/types/types.ts";
import TagManager from "react-gtm-module";

// used to track when user clicks on the accommodation preview "view details"
export const handleGTMPreviewAccommodationClick = (RG: RateGroup) => {
  const previewedRGAndRPs = RG.ratePlans?.map(
    (RP, index): GTMAccommodationItem => ({
      item_id: RP.id,
      item_name: RP.name,
      currency: "EUR",
      price: RP.lowestPrice,
      index,
      item_category: RG.name,
    }),
  );

  TagManager.dataLayer({ dataLayer: { ecommerce: null } });
  TagManager.dataLayer({
    dataLayer: {
      event: GTMEvent.SelectItem,
      ecommerce: {
        items: [previewedRGAndRPs],
      },
    },
  });
};

// used to track when the accommodation preview popup opens
export const handleGTMPreviewAccommodationOpen = (RG: RateGroup) => {
  const previewedRGAndRPs = RG.ratePlans?.map(
    (RP, index): GTMAccommodationItem => ({
      item_id: RP.id,
      item_name: RP.name,
      currency: "EUR",
      price: RP.lowestPrice,
      index,
      item_category: RG.name,
    }),
  );

  TagManager.dataLayer({ dataLayer: { ecommerce: null } });
  TagManager.dataLayer({
    dataLayer: {
      event: GTMEvent.ViewItem,
      ecommerce: {
        items: [previewedRGAndRPs],
      },
    },
  });
};
